module.exports = __webpack_public_path__ + "static/media/Sprout.4549adf9.svg";